<mat-table
  [dataSource]="items"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="baseType">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.coreType' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.baseType?.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="host">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.host' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.host }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="serverId">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.serverId' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.serverId }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="storageSize">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.storageSizeTb' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.reportMeta?.externalFleetManagementStorageSize | fsNumber : '1.0-2' }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="serialNumber">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.serialNumber' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.serialNumber }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="location">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.location' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.location?.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="totalCameras">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.totalCameras' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span>
        <mat-chip
          *ngIf="item.cameraCounts.countTotalCameras || displayZeroCounts"
          class="totalAppliances"
          (click)="onChipClick(item)"
        >
          <div class="chipTotalStatus">
            <span>{{ 'common.total' | t }}: </span>
            <span>{{ item.cameraCounts.countTotalCameras | fsNumber }}</span>
          </div>
        </mat-chip>
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.status' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span>
        <sn-appliance-status
          matTooltipPosition="below"
          [matTooltip]="item.statusChangeAt | snTimeToNow"
          [status]="item.status"
        >
        </sn-appliance-status>
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="capacityStatus">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.capacityStatus' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span>
        <fs-appliance-capacity-status
          matTooltipPosition="below"
          [applianceId]="item.id"
          [matTooltip]="item.capacityStatusChangeAt | snTimeToNow"
          [capacityStatus]="item.capacityStatus"
        >
        </fs-appliance-capacity-status>
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" [strictCollapse]="true"></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
